import { css } from '@emotion/react';

import { useWidgetContext } from '@widget/core';
import { useValuationContext } from '@widget/valuation';
import { MainLayout, HeaderV3 } from '../components';

import type { USPItemProps } from '../components';
import type { ImageAsset, TrustIcon } from '@widget/core';
import type { ReactNode } from 'react';
import type { Richtext } from 'storyblok-js-client';

const classes = {
  root: css`
    form {
      display: flex;
      flex-grow: 1;
      margin: 0 auto;
      max-width: 100%;
    }
  `,
  footer: css`
    width: 100%;
    align-items: center;
    justify-content: space-between;
  `,
};

export type WidgetLayoutProps = {
  children: ReactNode;
  onClickLogo?: () => void;
  logo?: ImageAsset;
  trustIconsList?: TrustIcon[] | null;
  contactPerson?: ImageAsset;
  marketingHeaderText?: Richtext | string;
  closeButtonText?: string | null;
  footerItems?: USPItemProps[] | undefined | null;
  localizedUspLabel?: string | undefined | null;
  closeModalTitle?: string | undefined | null;
  closeModalSubtitle?: Richtext | string | undefined | null;
  closeModalCloseModalText?: string | undefined | null;
  closeModalCloseWidgetText?: string | undefined | null;
  showCloseIcon?: boolean;
};

export function WidgetLayout({
  children,
  onClickLogo,
  logo,
  marketingHeaderText,
  closeButtonText,
  trustIconsList,
  footerItems,
  localizedUspLabel,
  closeModalTitle,
  closeModalCloseModalText,
  closeModalCloseWidgetText,
  closeModalSubtitle,
  showCloseIcon = false,
}: WidgetLayoutProps): JSX.Element {
  const { activeId, getStepProps } = useWidgetContext();
  const { valuation } = useValuationContext();
  const showValuation = !getStepProps(activeId)?.hideLiveValuation;
  const hideUSP = getStepProps(activeId)?.hideUSP;
  const uspLayout = getStepProps(activeId)?.uspLayout;
  const swapUspTextAndTrustIcons = getStepProps(activeId)?.swapUspTextAndTrustIcons;
  const fullWidthLayout = getStepProps(activeId)?.fullWidthLayout;
  const showFooter = !getStepProps(activeId)?.hideFooter;

  return (
    <MainLayout
      upsItems={footerItems}
      showFooter={showFooter}
      trustIconsList={trustIconsList}
      css={classes.root}
      hideUSP={hideUSP}
      uspLayout={uspLayout}
      swapUspTextAndTrustIcons={swapUspTextAndTrustIcons}
      fullWidthLayout={fullWidthLayout}
      localizedUspLabel={localizedUspLabel}
      header={
        <HeaderV3
          logo={logo}
          showValuation={showValuation}
          valuation={valuation}
          onClickLogo={onClickLogo}
          marketingHeaderText={marketingHeaderText}
          closeText={closeButtonText}
          closeModalTitle={closeModalTitle}
          closeModalSubtitle={closeModalSubtitle}
          closeModalCloseModalText={closeModalCloseModalText}
          closeModalCloseWidgetText={closeModalCloseWidgetText}
          trustIconsList={trustIconsList}
          showCloseIcon={showCloseIcon}
        />
      }
    >
      {children}
    </MainLayout>
  );
}
